import { render } from "./signingFormBase.vue?vue&type=template&id=05e5f69d"
import script from "./signingFormBase.vue?vue&type=script&lang=js"
export * from "./signingFormBase.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__